module.exports = __webpack_public_path__ + "static/img/banner-01.632c664.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/banner-01.jpg
// module id = Rvqw
// module chunks = 1